import { render, staticRenderFns } from "./Mde.vue?vue&type=template&id=bf08cd3e&scoped=true"
import script from "./Mde.vue?vue&type=script&lang=js"
export * from "./Mde.vue?vue&type=script&lang=js"
import style0 from "./Mde.vue?vue&type=style&index=0&id=bf08cd3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf08cd3e",
  null
  
)

export default component.exports